import axios from '../../functions/axios';
import { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { parseDate } from '../../functions/functions';
import { DateSelector } from './DateSelector';
import { useAuthContext } from '../../hooks/useAuthContext';
import { GeneralStatistics } from './GeneralStatistics';
import { CarsStatistics } from './CarsStatistics';
import { FormControl, Box, Tab, Tabs, Typography, Grid, CircularProgress } from '@mui/material';
const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const DataLoading = () => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
      <CircularProgress />
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>Pobieranie danych</Box>
    </Box>
  );
};

const DisplayFinalData = ({ loading, apiData, component }) => {
  if (loading) {
    return <DataLoading />;
  }
  if (!apiData.length) {
    return <Box style={{ color: '#cc0000' }}>Wybierz zakres dat, i kliknij "Szukaj"</Box>;
  }
  return component;
};

function Statistics(props) {
  const [apiData, setApiData] = useState([]);
  const [value, setValue] = useState(0);
  const [dayStart, setDayStart] = useState(parseDate(localStorage.getItem('statistics.dayStart') || new Date()).day);
  const [dayEnd, setDayEnd] = useState(parseDate(localStorage.getItem('statistics.dayEnd') || new Date()).day);
  const [cars, setCars] = useState([]);
  const [employee, setEmployee] = useState([]);
  const { user } = useAuthContext();
  const [loading, setLoading] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const handleTabChange = (event, newValue) => setValue(newValue);

  useEffect(() => {
    if (!user) return;
    // (async () => {
    //   try {
    //     const response = await axios.get('/users');
    //     setEmployee(response.data);
    //   } catch (err) {
    //     console.log(err);
    //   }
    // })();
    (async () => {
      try {
        const response = await axios.get('/car');
        setCars(response.data);
      } catch (err) {
        console.log(err);
      }
    })();
  }, [user]);

  const getData = async () => {
    try {
      const response = await axios.get('/statistics', {
        params: {
          startDate: parseDate(dayStart).day,
          endDate: parseDate(dayEnd).day,
        },
      });
      setApiData(response.data);
      await wait(1000);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', margin: '15px' }}>
        <Tabs value={value} onChange={handleTabChange}>
          <Tab label='Ogólne' />
          <Tab label='Pojazdy' />
          <Tab label='Pracownicy' />
        </Tabs>
      </Box>
      <DateSelector
        dayStart={dayStart}
        dayEnd={dayEnd}
        setDayStart={setDayStart}
        setDayEnd={setDayEnd}
        searchButtonClick={getData}
        setApiData={setApiData}
        setLoading={setLoading}
        buttonDisabled={buttonDisabled}
        setButtonDisabled={setButtonDisabled}
      />
      <TabPanel value={value} index={0}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <DisplayFinalData
            apiData={apiData}
            loading={loading}
            component={
              <GeneralStatistics data={apiData} dateStart={dayStart} dateEnd={dayEnd} />
            }
          />
        </Box>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
          <DisplayFinalData
            apiData={apiData}
            loading={loading}
            component={
              <CarsStatistics cars={cars} data={apiData} dateStart={dayStart} dateEnd={dayEnd} />
            }
          />
        </Box>
      </TabPanel>
      <TabPanel value={value} index={2}>
        Dostępne wkrótce
      </TabPanel>
      <FormControl sx={{ m: 1, width: 300 }}></FormControl>
    </>
  );
}

export default Statistics;
